import React from 'react';
export var ProFormContext = /*#__PURE__*/React.createContext({});